import { jwtAxiosInst } from '@thingsw/pitta-modules';

interface ICloudStorageUsage {
  devName: string;
  limit: number;
  psn: string;
  regCategory: string;
  usage: number;
}

export const getCloudStorageUsage = async ({
  email,
  psnList,
}: {
  email: string;
  psnList?: string[];
}) => {
  if (psnList && psnList?.length > 0) {
    const res = await jwtAxiosInst.get<{ response: ICloudStorageUsage[] }>(
      `/cloudStorage/usage-account?email=${email}&psnList=${psnList.join(',')}`
    );

    return res.data.response;
  } else {
    const res = await jwtAxiosInst.get<{ response: ICloudStorageUsage[] }>(
      `/cloudStorage/usage-account?email=${email}`
    );

    return res.data.response;
  }
};
